<template>
    <div class="w-100">
        <v-expansion-panels
            v-model = "year"
            class   = "pa-1"
            accordion
            flat
        >
            <v-expansion-panel
                class = "mt-0 mb-1"
                :key  = "yearList.year"
                v-for = "yearList in maintenanceList"
            >
                <v-expansion-panel-header
                    color       = "primary"
                    class       = "ml-0 pr-0"
                    expand-icon = "mdi-menu-down"
                >
                    <div class="v-flex white--text">
                        <div>
                            {{ yearList.year }}
                        </div>
                        <v-spacer />
                        <div>
                            {{ yearList.entries.length }} x
                        </div>
                    </div>
                </v-expansion-panel-header>

                <v-expansion-panel-content
                    class="white"
                >
                    <v-list
                        class="pt-0 pb-0 mt-1"
                    >
                        <v-list-item
                            class  = "pl-0 ml-0"
                            :class = "background(maintenence)"
                            @click = "onSelected(maintenence)"
                            :ripple = "false"
                            v-for  = "(maintenence, index) in yearList.entries" :key="yearList.year + '-' + index"
                            link
                        >
                            <v-list-item-title class="v-flex pl-2" >
                                {{ format(maintenence.executiondate)}}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";

export default {
    name: "CIncMaintenanceIndex",

    props: {
        maintenanceList: {

        }
    },

    data: () => ({
        year: 0,
        selected: null,
    }),

    computed: {
     },

    methods: {
        onSelected (maintenence) {
            if (maintenence === this.selected) {
                this.selected = null;
                this.$emit("selected", null);
                return;
            }

            this.selected = maintenence;
            this.$emit("selected", maintenence);
        },

        background(maintenence) {
            if (!this.selected) {
                return null;
            }

            if (this.selected === maintenence) {
                return "secondary lighten-4"
            }
        },


        format (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>


::v-deep .v-expansion-panel-header, .v-expansion-panel--active>.v-expansion-panel-header, .v-list-item {
    padding-left: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    min-height: 32px;
    border-radius: 4px;
}

::v-deep .v-expansion-panel-header__icon i {
    font-size: 32px!important;
    color: white!important;
}

::v-deep .v-expansion-panel-content__wrap {
    padding: 0;
    min-height: 30px;
}

::v-deep .theme--light.v-list-item:hover {
    background: aliceblue;
    color: black!important;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: black!important;
}

::v-deep .v-list-item {
    padding: 0;
}

::v-deep .v-list-item--link {
    margin-right: 0;
}

</style>